import { useState } from "react";
import dayjs from "dayjs";
import { Input } from "@/pages/quiz/15000/components/Input";
import { useManageInputFields } from "@/pages/quiz/hooks/useManageInputFields";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { validateDate } from "@/utils/validateField/date";
import { withMask } from "use-mask-input";
import { Button } from "@/pages/quiz/15000/components/Button";

type FormFieldName = "date";
type ContactFieldsValues = Record<FormFieldName, string>;

const validationFields = {
  date: {
    customValidator: validateDate,
    required: true,
  },
};

const CustomDate = ({
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<ContactFieldsValues>) => {
  const { registerField, onValidateForm, error } = useManageInputFields(
    {
      setQuestionValue,
      questionValue,
    },
    validationFields
  );

  const isNoErrors = Object.values(error).every(
    (errorMessage) => !errorMessage
  );

  const isAllAnswered =
    Object.values(questionValue).filter(Boolean).length === 1;

  const isFormAnswered = isAllAnswered && isNoErrors;

  const onSubmit = async () => {
    if (isFormAnswered) {
      setQuestionAnswer(questionValue);
    }
  };

  return (
    <>
      <Input
        {...registerField("date")}
        ref={withMask("99/99/9999", {
          jitMasking: true,
          showMaskOnHover: false,
        })}
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder="MM/DD/YYYY"
        errorMessage={error?.date}
      />

      <Button disabled={!isFormAnswered} onClick={onValidateForm(onSubmit)} />
    </>
  );
};

export { CustomDate };
